/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CategoryDto model module.
 * @module model/CategoryDto
 * @version v1.0.0
 */
class CategoryDto {
    /**
     * Constructs a new <code>CategoryDto</code>.
     * @alias module:model/CategoryDto
     */
    constructor() { 
        
        CategoryDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CategoryDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CategoryDto} obj Optional instance to populate.
     * @return {module:model/CategoryDto} The populated <code>CategoryDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CategoryDto();

            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} description
 */
CategoryDto.prototype['description'] = undefined;

/**
 * @member {String} id
 */
CategoryDto.prototype['id'] = undefined;

/**
 * @member {String} name
 */
CategoryDto.prototype['name'] = undefined;

/**
 * @member {Number} seq
 */
CategoryDto.prototype['seq'] = undefined;






export default CategoryDto;

